import { render, staticRenderFns } from "./WorkIconOrdered.vue?vue&type=template&id=9999c036"
import script from "./WorkIconOrdered.vue?vue&type=script&lang=js"
export * from "./WorkIconOrdered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports